import { useEffect, useState } from "react";
import { ICompany, ITheme } from "../../types";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../api";
import { Header } from "../../components/Header";

const COMPANY_ID = "LtDzf5QITuidufvhdjXdL";

export const Articles = () => {
  const [data, setData] = useState<any[]>([]);

  // const { company_id } = useParams();
  const history = useNavigate();

  const getArticles = async () => {
    const res = await API.getCompany(COMPANY_ID);
    setData(res);
  };

  const clickHandler = (id: string) => {
    history(id);
  };

  const ideaHandler = () => {
    history("idea");
  };

  useEffect(() => {
    getArticles();
  }, []);

  if (!data) return null;

  return (
    <>
      <h1>Инструкции</h1>
      <div>
        {data.map((theme) => (
          <div key={theme.id} className="card">
            <h4>{theme.name}</h4>
            <div className="theme_desciption">{theme.description}</div>
            <div>
              {theme.articles.map((article: any) => (
                <div className="article" onClick={() => clickHandler(article.id)}>
                  {article.index}. {article.name}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* <h1>{company.name}</h1>
      <div>
        {company.themes.map((theme) => (
          <div key={theme.id} className="card">
            <h4>{theme.name}</h4>
            <div>
              {theme.articles.map((article) => (
                <div className="article" onClick={() => clickHandler(article.id)}>
                  {article.name}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div> */}

      {/* <div>
        <div className="card" onClick={ideaHandler}>
          💡 Предложить идею
        </div>
      </div> */}
    </>
  );
};
